import React, { createContext, useState, useContext, useCallback } from "react";
import fr from "../languages/fr.json";
import en from "../languages/en.json";

const languages = { fr, en };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [currentLanguageCode, setCurrentLanguageCode] = useState(
    localStorage.currentLanguageCode || "fr",
  );

  const changeLanguage = useCallback((code) => {
    localStorage.setItem("currentLanguageCode", code);
    setCurrentLanguageCode(code);
  }, []);

  const strings = languages[currentLanguageCode] || languages.fr;

  return (
    <LanguageContext.Provider
      value={{ currentLanguageCode, strings, changeLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function withLanguage(Component) {
  function WithLanguageWrapper(props) {
    const lang = useLanguage();
    return <Component {...props} {...lang} />;
  }
  WithLanguageWrapper.displayName = `withLanguage(${Component.displayName || Component.name || "Component"})`;
  return WithLanguageWrapper;
}
